import React, { Component } from "react"
import "./Table.scss";

import TableImg from "./img/Table.svg"

class Table extends Component {
    render() {
        return (
          <ul>
            <li
                id={"Table_"+this.props.id}
                className="Table">
                <img src={TableImg} alt={'Laboratory shelf'} />
            </li>
          </ul>
        )
    }
}
export default Table;
